import { useState, useEffect, useCallback } from "react";
import "./noAdResults.css";
import AdCard from "../AdCard/AdCard";
import { fetchFilteredAds } from "../api/AdPageAPI";
import Spinner from "../../../components/Spinner/Spinner";

export default function NoResults({ allFilters, totalAds, excludedIds = [] }) {
  const [fallbackAds, setFallbackAds] = useState([]);
  const [fallbackLevel, setFallbackLevel] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const getRelaxedFilters = useCallback(
    (level) => {
      const relaxed = { ...allFilters };

      if (level >= 1) {
        delete relaxed.min_rent;
        delete relaxed.max_rent;
      }

      if (level >= 2) {
        delete relaxed.min_area;
        delete relaxed.max_area;
      }

      if (level >= 3) {
        delete relaxed.type_of_room;
      }

      if (level >= 4) {
        delete relaxed.zone;
      }

      if (level >= 5) {
        delete relaxed.municipality;
      }

      return relaxed;
    },
    [allFilters],
  );

  const fetchFallbackAds = useCallback(async () => {
    try {
      setIsLoading(true);

      if (totalAds > 5) {
        setIsLoading(false);
        return;
      }

      // Try each relaxation level
      for (let level = 0; level <= 5; level++) {
        const relaxedFilters = getRelaxedFilters(level);

        const result = await fetchFilteredAds({
          filterParams: relaxedFilters,
          currentPage: 1,
          adsPerPage: 6,
          sortingOption: "createdAt",
          setId: () => {},
          setTotalPages: () => {},
          setTotalAds: () => {},
          searchTerm: "",
          setAllAds: () => {},
          setIsLoading: () => {},
        });

        // Filtrera bort annonser som redan visas
        const filteredResult = result.filter(
          (ad) => !excludedIds.includes(ad._id),
        );

        if (filteredResult && filteredResult.length > 0) {
          setFallbackAds(filteredResult.slice(0, 6));
          setFallbackLevel(level);
          setIsLoading(false);
          return;
        }
      }

      // Om ingen resultat ens på level 5, sätt tom array
      setFallbackAds([]);
      setIsLoading(false);
    } catch (error) {
      setErrorMessage("Kunde inte ladda annonser. Försök igen.");
      setIsLoading(false);
    }
  }, [totalAds, getRelaxedFilters, excludedIds]);

  useEffect(() => {
    fetchFallbackAds();
  }, [fetchFallbackAds]);

  if (isLoading) {
    return (
      <div className="no-results-ad-section">
        <Spinner />
      </div>
    );
  }

  // Bestäm rubrik baserat på vilken nivå som användes
  const getHeading = () => {
    if (fallbackLevel === 3) return "Andra lokaltyper nära ditt sökområde";
    if (fallbackLevel === 4) return "Andra lediga lokaler i samma kommun";
    if (fallbackLevel === 5) return "Andra lediga lokaler i Sverige";
    return "Liknande lokaler nära ditt sökområde";
  };

  return (
    <div className="no-results-ad-section">
      {fallbackAds.length > 0 && (
        <section className="no-result-section">
          <h2>{getHeading()}</h2>
          <div className="fallback-grid">
            {fallbackAds.map((ad) => (
              <AdCard key={ad._id} id={ad} />
            ))}
          </div>
        </section>
      )}
      {errorMessage && <p className="no-ads-errormsg">{errorMessage}</p>}
    </div>
  );
}
